import { render, staticRenderFns } from "./WiFiButton.vue?vue&type=template&id=52438d32&scoped=true&"
import script from "./WiFiButton.vue?vue&type=script&setup=true&lang=ts&"
export * from "./WiFiButton.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./WiFiButton.vue?vue&type=style&index=0&id=52438d32&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52438d32",
  null
  
)

export default component.exports